<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-layout row justify-center>


    </v-layout>
    <v-layout row wrap>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title> {{ $t('Advance-Tax-Parameters') }} </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="$t('Search')" append-icon="search">
        </v-text-field>



        <v-tooltip bottom>
          <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="yeniekle()" flat> <span
              class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Add') }}</span>
            </span>
            <v-icon right dark>add_box</v-icon>
          </v-btn>

          <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
          <span v-if="sayfayetki.Save"> {{ $t('Add-v2', { value: $t('Ticket-Agent')}) }}      </span>
        </v-tooltip>

      </v-toolbar>
    </v-layout>

    <v-dialog v-model="dialog" v-if="dialog" scrollable="" persistent="" max-width="800px">
      <v-card color="grey lighten-5">
        <v-card-title> {{ $t('Advance-Tax-Definition') }} </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
            <v-layout row wrap>


              <v-flex xs12 sm12 md12>
                <v-select :items="itemsKayitTipi" hide-details="" item-text="Aciklama"
                  v-model="VergiParametreYedek.RecordType" item-value="Kod" :label="$t('Record-Type')"></v-select>
              </v-flex>
              <v-flex xs12 sm2 md3>
                <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="true" :rules="[v => !!v || $t('Please-select-a-date')]"
                  v-bind:defaultvalue="'ok'" v-bind:value="VergiParametreYedek.BaslangicTarih"
                  v-model="VergiParametreYedek.BaslangicTarih"></tarihcomp>
              </v-flex>

              <v-flex xs12 sm2 md3>
                <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="true" :rules="[v => !!v || $t('Please-select-a-date')]"
                  v-bind:defaultvalue="'ok'" v-bind:value="VergiParametreYedek.BitisTarih"
                  v-model="VergiParametreYedek.BitisTarih">
                </tarihcomp>
              </v-flex>

              <v-flex xs12 sm12 md6>
                <v-text-field hide-details="" :rules="[v => !!v || $t('Please-select-a-date')]"
                  v-model="VergiParametreYedek.Aciklama" :label="$t('General-Description')">
                </v-text-field>
              </v-flex>

            </v-layout>
            <v-layout>
              <v-flex xs12 sm4 md2>
                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Amount')" :aktif="'false'" v-model="defaultvalue"
                  :autocomplete="'autocomplete'">
                </parainput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametreYedek.BiletKdv" :autocomplete="'autocomplete'">
                </yuzdeinput>
              </v-flex>
              {{VergiParametreYedek.BiletKdv}}
              <v-flex xs12 sm4 md2>
                <v-select hide-details="" v-model="VergiParametreYedek.BiletDH" :items="itemsei" clearable label="E/I">
                </v-select>
              </v-flex>
              <v-flex xs12 sm4 md5>
                <v-text-field hide-details="" v-model="VergiParametreYedek.BiletAciklama" :label="$t('Description')">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md1>
                <v-checkbox v-model="VergiParametreYedek.BiletDisp" hide-details></v-checkbox>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 sm4 md2>
                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="'Pta Tutar'" :aktif="'false'" v-model="defaultvalue"
                  :autocomplete="'autocomplete'">
                </parainput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametreYedek.PtaKdv" :autocomplete="'autocomplete'">
                </yuzdeinput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <v-select hide-details="" v-model="VergiParametreYedek.PtaDH" :items="itemsei" clearable label="E/I">
                </v-select>
              </v-flex>
              <v-flex xs12 sm4 md5>
                <v-text-field hide-details="" v-model="VergiParametreYedek.PtaAciklama" :label="$t('Description')">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md1>
                <v-checkbox v-model="VergiParametreYedek.PtaDisp" hide-details></v-checkbox>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 sm4 md2>
                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="'YFF Tutar'" v-model="VergiParametreYedek.YffTutar"
                  :autocomplete="'autocomplete'">
                </parainput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametreYedek.YffKdv" :autocomplete="'autocomplete'">
                </yuzdeinput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <v-select hide-details="" v-model="VergiParametreYedek.YffDH" :items="itemsei" clearable label="E/I">
                </v-select>
              </v-flex>
              <v-flex xs12 sm4 md5>
                <v-text-field hide-details="" v-model="VergiParametreYedek.YffAciklama" :label="$t('Description')">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md1>
                <v-checkbox v-model="VergiParametreYedek.YffDisp" hide-details></v-checkbox>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 sm4 md2>
                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Landing-Tax-Amount')"
                  v-model="VergiParametreYedek.AlanVergisiTutar" :autocomplete="'autocomplete'"></parainput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametreYedek.AlanVergisiKdv"
                  :autocomplete="'autocomplete'">
                </yuzdeinput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <v-select hide-details="" v-model="VergiParametreYedek.AlanVergisiDH" :items="itemsei" clearable
                  label="E/I">
                </v-select>
              </v-flex>
              <v-flex xs12 sm4 md5>
                <v-text-field hide-details="" v-model="VergiParametre.AlanVergisiAciklama" :label="$t('Description')">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md1>
                <v-checkbox v-model="VergiParametreYedek.AlanVergisiDisp" hide-details></v-checkbox>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 sm4 md2>
                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="'Tax1 Tutar'" v-model="VergiParametreYedek.Tax1Tutar"
                  :autocomplete="'autocomplete'">
                </parainput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametreYedek.Tax1Kdv" :autocomplete="'autocomplete'">
                </yuzdeinput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <v-select hide-details="" v-model="VergiParametreYedek.Tax1DH" :items="itemsei" clearable label="E/I">
                </v-select>
              </v-flex>
              <v-flex xs12 sm4 md5>
                <v-text-field hide-details="" v-model="VergiParametreYedek.Tax1Aciklama" :label="$t('Description')">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md1>
                <v-checkbox v-model="VergiParametreYedek.Tax1Disp" hide-details></v-checkbox>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 sm4 md2>
                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="'Tax2 Tutar'" v-model="VergiParametreYedek.Tax2Tutar"
                  :autocomplete="'autocomplete'">
                </parainput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametreYedek.Tax2Kdv" :autocomplete="'autocomplete'">
                </yuzdeinput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <v-select hide-details="" v-model="VergiParametreYedek.Tax2DH" :items="itemsei" clearable label="E/I">
                </v-select>
              </v-flex>
              <v-flex xs12 sm4 md5>
                <v-text-field hide-details="" v-model="VergiParametreYedek.Tax2Aciklama" :label="$t('Description')">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md1>
                <v-checkbox v-model="VergiParametreYedek.Tax2Disp" hide-details></v-checkbox>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 sm4 md2>
                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="'Tax3 Tutar'" v-model="VergiParametreYedek.Tax3Tutar"
                  :autocomplete="'autocomplete'">
                </parainput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametreYedek.Tax3Kdv" :autocomplete="'autocomplete'">
                </yuzdeinput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <v-select hide-details="" v-model="VergiParametreYedek.Tax3DH" :items="itemsei" clearable label="E/I">
                </v-select>
              </v-flex>
              <v-flex xs12 sm4 md5>
                <v-text-field hide-details="" v-model="VergiParametreYedek.Tax3Aciklama" :label="$t('Description')">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md1>
                <v-checkbox v-model="VergiParametreYedek.Tax3Disp" hide-details></v-checkbox>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 sm4 md2>
                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="'Tax4 Tutar'" v-model="VergiParametreYedek.Tax4Tutar"
                  :autocomplete="'autocomplete'">
                </parainput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametreYedek.Tax4Kdv" :autocomplete="'autocomplete'">
                </yuzdeinput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <v-select hide-details="" v-model="VergiParametreYedek.Tax4DH" :items="itemsei" clearable label="E/I">
                </v-select>
              </v-flex>
              <v-flex xs12 sm4 md5>
                <v-text-field hide-details="" v-model="VergiParametreYedek.Tax4Aciklama" :label="$t('Description')">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md1>
                <v-checkbox v-model="VergiParametreYedek.Tax4Disp" hide-details></v-checkbox>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 sm4 md2>
                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Other-Service-Amount')"
                  v-model="VergiParametreYedek.DigerServisTutar" :autocomplete="'autocomplete'"></parainput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametreYedek.DigerServisKdv"
                  :autocomplete="'autocomplete'">
                </yuzdeinput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <v-select hide-details="" v-model="VergiParametreYedek.DigerServisDH" :items="itemsei" clearable
                  label="E/I">
                </v-select>
              </v-flex>
              <v-flex xs12 sm4 md5>
                <v-text-field hide-details="" v-model="VergiParametreYedek.DigerServisAciklama" :label="$t('Description')">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md1>
                <v-checkbox v-model="VergiParametreYedek.DigerServisDisp" hide-details></v-checkbox>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 sm4 md2>
                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Domestic-Service-Amount')"
                  v-model="VergiParametreYedek.IcServisTutar" :autocomplete="'autocomplete'"></parainput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametreYedek.IcServisKdv" :autocomplete="'autocomplete'">
                </yuzdeinput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <v-select hide-details="" v-model="VergiParametreYedek.IcServisDH" :items="itemsei" clearable
                  label="E/I">
                </v-select>
              </v-flex>
              <v-flex xs12 sm4 md5>
                <v-text-field hide-details="" v-model="VergiParametreYedek.IcServisAciklama" :label="$t('Description')">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md1>
                <v-checkbox v-model="VergiParametreYedek.IcServisDisp" hide-details></v-checkbox>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 sm4 md2>
                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('International-Service-Amount')"
                  v-model="VergiParametreYedek.DisServisTutar" :autocomplete="'autocomplete'"></parainput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametreYedek.DisServisKdv" :autocomplete="'autocomplete'">
                </yuzdeinput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <v-select hide-details="" v-model="VergiParametreYedek.DisServisDH" :items="itemsei" clearable
                  label="E/I">
                </v-select>
              </v-flex>
              <v-flex xs12 sm4 md5>
                <v-text-field hide-details="" v-model="VergiParametreYedek.DisServisAciklama" :label="$t('Description')">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md1>
                <v-checkbox v-model="VergiParametreYedek.DisServisDisp" hide-details></v-checkbox>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 sm4 md2>
                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('One-way-EKP')" v-model="VergiParametreYedek.TekYonTutar"
                  :autocomplete="'autocomplete'">
                </parainput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametreYedek.TekYonKdv" :autocomplete="'autocomplete'">
                </yuzdeinput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <v-select hide-details="" v-model="VergiParametreYedek.TekYonDH" :items="itemsei" clearable label="E/I">
                </v-select>
              </v-flex>
              <v-flex xs12 sm4 md5>
                <v-text-field hide-details="" v-model="VergiParametreYedek.TekYonAciklama" :label="$t('Description')">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md1>
                <v-checkbox v-model="VergiParametreYedek.TekYonDisp" hide-details></v-checkbox>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 sm4 md2>
                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Return-EKP')" v-model="VergiParametreYedek.GDonusTutar"
                  :autocomplete="'autocomplete'">
                </parainput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametreYedek.GDonusKdv" :autocomplete="'autocomplete'">
                </yuzdeinput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <v-select hide-details="" v-model="VergiParametreYedek.GDonusDH" :items="itemsei" clearable label="E/I">
                </v-select>
              </v-flex>
              <v-flex xs12 sm4 md5>
                <v-text-field hide-details="" v-model="VergiParametreYedek.GDonusAciklama" :label="$t('Description')">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md1>
                <v-checkbox v-model="VergiParametreYedek.GDonusDisp" hide-details></v-checkbox>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 sm4 md2>
                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Variable-Amount')"
                  v-model="VergiParametreYedek.ReserveTutar" :autocomplete="'autocomplete'"></parainput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametreYedek.ReserveKdv" :autocomplete="'autocomplete'">
                </yuzdeinput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <v-select hide-details="" v-model="VergiParametreYedek.ReserveDH" :items="itemsei" clearable
                  label="E/I">
                </v-select>
              </v-flex>
              <v-flex xs12 sm4 md5>
                <v-text-field hide-details="" v-model="VergiParametreYedek.ReserveAciklama" :label="$t('Description')">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md1>
                <v-checkbox v-model="VergiParametreYedek.ReserveDisp" hide-details></v-checkbox>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 sm4 md2>
                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Penalty-Amount')" v-model="VergiParametreYedek.CezaTutar"
                  :autocomplete="'autocomplete'">
                </parainput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametreYedek.CezaKdv" :autocomplete="'autocomplete'">
                </yuzdeinput>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <v-select hide-details="" v-model="VergiParametreYedek.CezaDH" :items="itemsei" clearable label="E/I">
                </v-select>
              </v-flex>
              <v-flex xs12 sm4 md5>
                <v-text-field hide-details="" v-model="VergiParametreYedek.CezaAciklama" :label="$t('Description')">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md1>
                <v-checkbox v-model="VergiParametreYedek.CezaDisp" hide-details></v-checkbox>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="dialog=false">{{$t("cancel_button")}}</v-btn>

          <v-btn color="blue darken-1" flat @click.native="Kaydet()">{{$t("save_button")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

      </v-card-title>




      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
        :search="search3">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr item>
            <td class="text-xs-left">{{ props.item.RecordType | kayittipi }}</td>
            <td class="text-xs-left">{{ props.item.BaslangicTarih | dateformat }}</td>
            <td class="text-xs-left">{{ props.item.BitisTarih | dateformat }}</td>
            <td class="text-xs-left">{{ props.item.Aciklama }}</td>
            <td class="justify-end layout px-0">
              <v-icon color="green" @click="Getir(props.item)">
                edit
              </v-icon> &nbsp;&nbsp;
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
           {{ $t('No-records-searched-for', { value: search3}) }}
        </v-alert>
      </v-data-table>
    </v-card>
    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from "@/components/app/customcomp/tarihim.vue";
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import parainput from "@/components/app/customcomp/parainput.vue"
  import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue"
  export default {
    data() {
      return {
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        itemsKayitTipi: helpers.getBiletKayitTipi,
        valid: true,
        defaultvalue: 0,
        itemsei: ['E', 'I'],
        VergiParametre: {
          SirketKodu: 0,
          RecordType: 0,
          BiletKdv: 0,
          BiletDH: null,
          BiletAciklama: null,
          BiletDisp: false,

          PtaKdv: 0,
          PtaDH: null,
          PtaAciklama: null,
          PtaDisp: false,

          YffTutar: 0,
          YffKdv: 0,
          YffDH: null,
          YffAciklama: null,
          YffDisp: false,

          AlanVergisiTutar: 0,
          AlanVergisiKdv: 0,
          AlanVergisiDH: null,
          AlanVergisiAciklama: null,
          AlanVergisiDisp: false,

          Tax1Tutar: 0,
          Tax1Kdv: 0,
          Tax1DH: null,
          Tax1Aciklama: null,
          Tax1Disp: false,

          Tax2Tutar: 0,
          Tax2Kdv: 0,
          Tax2DH: null,
          Tax2Aciklama: null,
          Tax2Disp: false,

          Tax3Tutar: 0,
          Tax3Kdv: 0,
          Tax3DH: null,
          Tax3Aciklama: null,
          Tax3Disp: false,

          Tax4Tutar: 0,
          Tax4Kdv: 0,
          Tax4DH: null,
          Tax4Aciklama: null,
          Tax4Disp: false,

          DigerServisTutar: 0,
          DigerServisKdv: 0,
          DigerServisDH: null,
          DigerServisAciklama: null,
          DigerServisDisp: false,

          IcServisTutar: 0,
          IcServisKdv: 0,
          IcServisDH: null,
          IcServisAciklama: null,
          IcServisDisp: false,

          DisServisTutar: 0,
          DisServisKdv: 0,
          DisServisDH: null,
          DisServisAciklama: null,
          DisServisDisp: false,

          TekYonTutar: 0,
          TekYonKdv: 0,
          TekYonDH: null,
          TekYonAciklama: null,
          TekYonDisp: false,

          GDonusTutar: 0,
          GDonusKdv: 0,
          GDonusDH: null,
          GDonusAciklama: null,
          GDonusDisp: false,

          ReserveTutar: 0,
          ReserveKdv: 0,
          ReserveDH: null,
          ReserveAciklama: null,
          ReserveDisp: false,

          CezaTutar: 0,
          CezaKdv: 0,
          CezaDH: null,
          CezaAciklama: null,
          CezaDisp: false,

          ReserveDisHatKdv: false,
          BaslangicTarih: null,
          BitisTarih: null,
          Aciklama: null,


        },
        VergiParametreYedek: {
          SirketKodu: 0,
          RecordType: 0,
          BiletKdv: 0,
          BiletDH: null,
          BiletAciklama: null,
          BiletDisp: false,

          PtaKdv: 0,
          PtaDH: null,
          PtaAciklama: null,
          PtaDisp: false,

          YffTutar: 0,
          YffKdv: 0,
          YffDH: null,
          YffAciklama: null,
          YffDisp: false,

          AlanVergisiTutar: 0,
          AlanVergisiKdv: 0,
          AlanVergisiDH: null,
          AlanVergisiAciklama: null,
          AlanVergisiDisp: false,

          Tax1Tutar: 0,
          Tax1Kdv: 0,
          Tax1DH: null,
          Tax1Aciklama: null,
          Tax1Disp: false,

          Tax2Tutar: 0,
          Tax2Kdv: 0,
          Tax2DH: null,
          Tax2Aciklama: null,
          Tax2Disp: false,

          Tax3Tutar: 0,
          Tax3Kdv: 0,
          Tax3DH: null,
          Tax3Aciklama: null,
          Tax3Disp: false,

          Tax4Tutar: 0,
          Tax4Kdv: 0,
          Tax4DH: null,
          Tax4Aciklama: null,
          Tax4Disp: false,

          DigerServisTutar: 0,
          DigerServisKdv: 0,
          DigerServisDH: null,
          DigerServisAciklama: null,
          DigerServisDisp: false,

          IcServisTutar: 0,
          IcServisKdv: 0,
          IcServisDH: null,
          IcServisAciklama: null,
          IcServisDisp: false,

          DisServisTutar: 0,
          DisServisKdv: 0,
          DisServisDH: null,
          DisServisAciklama: null,
          DisServisDisp: false,

          TekYonTutar: 0,
          TekYonKdv: 0,
          TekYonDH: null,
          TekYonAciklama: null,
          TekYonDisp: false,

          GDonusTutar: 0,
          GDonusKdv: 0,
          GDonusDH: null,
          GDonusAciklama: null,
          GDonusDisp: false,

          ReserveTutar: 0,
          ReserveKdv: 0,
          ReserveDH: null,
          ReserveAciklama: null,
          ReserveDisp: false,

          CezaTutar: 0,
          CezaKdv: 0,
          CezaDH: null,
          CezaAciklama: null,
          CezaDisp: false,

          ReserveDisHatKdv: false,
          BaslangicTarih: null,
          BitisTarih: null,
          Aciklama: null,


        },
        items: [],
        search3: '',
        selected: '',
        m: false,
        k: false,
        dialog: false,
        KesenKisi: {
          ID: null,
          SirketKodu: null,
          Kodu: null,
          Adi: null,
          Soyadi: null,
          PersonelKodu: null,
        },
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        analizkod: '',
        analizadi: '',
        tutar: '',
        oran: '',
        progress: false,
        dictionary: {
          custom: {
            kodu: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            adi: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            soyadi: {
              required: () => this.$t('This-space-cannot-left-blank'),
            }
          }
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)


      //bu kaldırılacak

      this.sayfayetki.Status = true
      this.sayfayetki.Save = true
      this.sayfayetki.Update = true
      this.sayfayetki.Delete = true

      if (this.sayfayetki.Status == true) {
        this.gecicivergibilgigetir();

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          }

        });

      }

    },
    methods: {
      yeniekle() {

        this.VergiParametreYedek.ID = null
        this.VergiParametreYedek.RecordType = 0
        this.VergiParametreYedek.BiletKdv = 0
        this.VergiParametreYedek.BiletDH = null
        this.VergiParametreYedek.BiletAciklama = null
        this.VergiParametreYedek.BiletDisp = false
        this.VergiParametreYedek.PtaKdv = 0
        this.VergiParametreYedek.PtaDH = null
        this.VergiParametreYedek.PtaAciklama = null
        this.VergiParametreYedek.PtaDisp = false

        this.VergiParametreYedek.YffTutar = 0
        this.VergiParametreYedek.YffKdv = 0
        this.VergiParametreYedek.YffDH = null
        this.VergiParametreYedek.YffAciklama = null
        this.VergiParametreYedek.YffDisp = false

        this.VergiParametreYedek.AlanVergisiTutar = 0
        this.VergiParametreYedek.AlanVergisiKdv = 0
        this.VergiParametreYedek.AlanVergisiDH = null
        this.VergiParametreYedek.AlanVergisiAciklama = null
        this.VergiParametreYedek.AlanVergisiDisp = false

        this.VergiParametreYedek.Tax1Tutar = 0
        this.VergiParametreYedek.Tax1Kdv = 0
        this.VergiParametreYedek.Tax1DH = null
        this.VergiParametreYedek.Tax1Aciklama = null
        this.VergiParametreYedek.Tax1Disp = false

        this.VergiParametreYedek.Tax2Tutar = 0
        this.VergiParametreYedek.Tax2Kdv = 0
        this.VergiParametreYedek.Tax2DH = null
        this.VergiParametreYedek.Tax2Aciklama = null
        this.VergiParametreYedek.Tax2Disp = false

        this.VergiParametreYedek.Tax3Tutar = 0
        this.VergiParametreYedek.Tax3Kdv = 0
        this.VergiParametreYedek.Tax3DH = null
        this.VergiParametreYedek.Tax3Aciklama = null
        this.VergiParametreYedek.Tax3Disp = false

        this.VergiParametreYedek.Tax4Tutar = 0
        this.VergiParametreYedek.Tax4Kdv = 0
        this.VergiParametreYedek.Tax4DH = null
        this.VergiParametreYedek.Tax4Aciklama = null
        this.VergiParametreYedek.Tax4Disp = false

        this.VergiParametreYedek.DigerServisTutar = 0
        this.VergiParametreYedek.DigerServisKdv = 0
        this.VergiParametreYedek.DigerServisDH = null
        this.VergiParametreYedek.DigerServisAciklama = null
        this.VergiParametreYedek.DigerServisDisp = false

        this.VergiParametreYedek.IcServisTutar = 0
        this.VergiParametreYedek.IcServisKdv = 0
        this.VergiParametreYedek.IcServisDH = null
        this.VergiParametreYedek.IcServisAciklama = null
        this.VergiParametreYedek.IcServisDisp = false

        this.VergiParametreYedek.DisServisTutar = 0
        this.VergiParametreYedek.DisServisKdv = 0
        this.VergiParametreYedek.DisServisDH = null
        this.VergiParametreYedek.DisServisAciklama = null
        this.VergiParametreYedek.DisServisDisp = false

        this.VergiParametreYedek.TekYonTutar = 0
        this.VergiParametreYedek.TekYonKdv = 0
        this.VergiParametreYedek.TekYonDH = null
        this.VergiParametreYedek.TekYonAciklama = null
        this.VergiParametreYedek.TekYonDisp = false

        this.VergiParametreYedek.GDonusTutar = 0
        this.VergiParametreYedek.GDonusKdv = 0
        this.VergiParametreYedek.GDonusDH = null
        this.VergiParametreYedek.GDonusAciklama = null
        this.VergiParametreYedek.GDonusDisp = false

        this.VergiParametreYedek.ReserveTutar = 0
        this.VergiParametreYedek.ReserveKdv = 0
        this.VergiParametreYedek.ReserveDH = null
        this.VergiParametreYedek.ReserveAciklama = null
        this.VergiParametreYedek.ReserveDisp = false

        this.VergiParametreYedek.CezaTutar = 0
        this.VergiParametreYedek.CezaKdv = 0
        this.VergiParametreYedek.CezaDH = null
        this.VergiParametreYedek.CezaAciklama = null
        this.VergiParametreYedek.CezaDisp = false

        this.VergiParametreYedek.ReserveDisHatKdv = false
        this.VergiParametreYedek.BaslangicTarih = null
        this.VergiParametreYedek.BitisTarih = null
        this.VergiParametreYedek.Aciklama = null


        this.dialog = true
      },
      gecicivergibilgigetir() {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params = {
          ID: null,
          CompanyCode: credentials.SirketKodu
        }

        this.$http.post(auth.API_URL + 'api/TicketParametre/TempTaxParamList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })


      },
      getparabirimi() {
        return helpers.getparabirimi()
      },

      Getir(v) {
        this.k = false
        this.m = true
        this.VergiParametreYedek.ID = v.ID
        this.VergiParametreYedek.RecordType = v.RecordType
        this.VergiParametreYedek.BiletKdv = v.BiletKdv
        this.VergiParametreYedek.BiletDH = v.BiletDH
        this.VergiParametreYedek.BiletAciklama = v.BiletAciklama
        this.VergiParametreYedek.BiletDisp = v.BiletDisp

        this.VergiParametreYedek.PtaKdv = v.PtaKdv
        this.VergiParametreYedek.PtaDH = v.PtaDH
        this.VergiParametreYedek.PtaAciklama = v.PtaAciklama
        this.VergiParametreYedek.PtaDisp = v.PtaDisp

        this.VergiParametreYedek.YffTutar = v.YffTutar
        this.VergiParametreYedek.YffKdv = v.YffKdv
        this.VergiParametreYedek.YffDH = v.YffDH
        this.VergiParametreYedek.YffAciklama = v.YffAciklama
        this.VergiParametreYedek.YffDisp = v.YffDisp

        this.VergiParametreYedek.AlanVergisiTutar = v.AlanVergisiTutar
        this.VergiParametreYedek.AlanVergisiKdv = v.AlanVergisiKdv
        this.VergiParametreYedek.AlanVergisiDH = v.AlanVergisiDH
        this.VergiParametreYedek.AlanVergisiAciklama = v.AlanVergisiAciklama
        this.VergiParametreYedek.AlanVergisiDisp = v.AlanVergisiDisp

        this.VergiParametreYedek.Tax1Tutar = v.Tax1Tutar
        this.VergiParametreYedek.Tax1Kdv = v.Tax1Kdv
        this.VergiParametreYedek.Tax1DH = v.Tax1DH
        this.VergiParametreYedek.Tax1Aciklama = v.Tax1Aciklama
        this.VergiParametreYedek.Tax1Disp = v.Tax1Disp

        this.VergiParametreYedek.Tax2Tutar = v.Tax2Tutar
        this.VergiParametreYedek.Tax2Kdv = v.Tax2Kdv
        this.VergiParametreYedek.Tax2DH = v.Tax2DH
        this.VergiParametreYedek.Tax2Aciklama = v.Tax2Aciklama
        this.VergiParametreYedek.Tax2Disp = v.Tax2Disp

        this.VergiParametreYedek.Tax3Tutar = v.Tax3Tutar
        this.VergiParametreYedek.Tax3Kdv = v.Tax3Kdv
        this.VergiParametreYedek.Tax3DH = v.Tax3DH
        this.VergiParametreYedek.Tax3Aciklama = v.Tax3Aciklama
        this.VergiParametreYedek.Tax3Disp = v.Tax3Disp

        this.VergiParametreYedek.Tax4Tutar = v.Tax4Tutar
        this.VergiParametreYedek.Tax4Kdv = v.Tax4Kdv
        this.VergiParametreYedek.Tax4DH = v.Tax4DH
        this.VergiParametreYedek.Tax4Aciklama = v.Tax4Aciklama
        this.VergiParametreYedek.Tax4Disp = v.Tax4Disp

        this.VergiParametreYedek.DigerServisTutar = v.DigerServisTutar
        this.VergiParametreYedek.DigerServisKdv = v.DigerServisKdv
        this.VergiParametreYedek.DigerServisDH = v.DigerServisDH
        this.VergiParametreYedek.DigerServisAciklama = v.DigerServisAciklama
        this.VergiParametreYedek.DigerServisDisp = v.DigerServisDisp

        this.VergiParametreYedek.IcServisTutar = v.IcServisTutar
        this.VergiParametreYedek.IcServisKdv = v.IcServisKdv
        this.VergiParametreYedek.IcServisDH = v.IcServisDH
        this.VergiParametreYedek.IcServisAciklama = v.IcServisAciklama
        this.VergiParametreYedek.IcServisDisp = v.IcServisDisp

        this.VergiParametreYedek.DisServisTutar = v.DisServisTutar
        this.VergiParametreYedek.DisServisKdv = v.DisServisKdv
        this.VergiParametreYedek.DisServisDH = v.DisServisDH
        this.VergiParametreYedek.DisServisAciklama = v.DisServisAciklama
        this.VergiParametreYedek.DisServisDisp = v.DisServisDisp

        this.VergiParametreYedek.TekYonTutar = v.TekYonTutar
        this.VergiParametreYedek.TekYonKdv = v.TekYonKdv
        this.VergiParametreYedek.TekYonDH = v.TekYonDH
        this.VergiParametreYedek.TekYonAciklama = v.TekYonAciklama
        this.VergiParametreYedek.TekYonDisp = v.TekYonDisp

        this.VergiParametreYedek.GDonusTutar = v.GDonusTutar
        this.VergiParametreYedek.GDonusKdv = v.GDonusKdv
        this.VergiParametreYedek.GDonusDH = v.GDonusDH
        this.VergiParametreYedek.GDonusAciklama = v.GDonusAciklama
        this.VergiParametreYedek.GDonusDisp = v.GDonusDisp

        this.VergiParametreYedek.ReserveTutar = v.ReserveTutar
        this.VergiParametreYedek.ReserveKdv = v.ReserveKdv
        this.VergiParametreYedek.ReserveDH = v.ReserveDH
        this.VergiParametreYedek.ReserveAciklama = v.ReserveAciklama
        this.VergiParametreYedek.ReserveDisp = v.ReserveDisp

        this.VergiParametreYedek.CezaTutar = v.CezaTutar
        this.VergiParametreYedek.CezaKdv = v.CezaKdv
        this.VergiParametreYedek.CezaDH = v.CezaDH
        this.VergiParametreYedek.CezaAciklama = v.CezaAciklama
        this.VergiParametreYedek.CezaDisp = v.CezaDisp

        this.VergiParametreYedek.ReserveDisHatKdv = v.ReserveDisHatKdv
        this.VergiParametreYedek.BaslangicTarih = v.BaslangicTarih
        this.VergiParametreYedek.BitisTarih = v.BitisTarih
        this.VergiParametreYedek.Aciklama = v.Aciklama

        this.dialog = true

      },
      sil: sil,
      ekle: ekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
    },
    computed:{
        headers(){
          return [{
            text: this.$t('Record-Type'),
            value: 'RecortType'
          },{
            text: this.$t('Starting-Date'),
            value: 'BaslangicTarih'
          },
          {
            text: this.$t('Finishing-Date'),
            value: 'BitisTarih'
          },
          {
            text: this.$t('Description'),
            value: 'Aciklama'
          },
          {
            text: '',
            value: ''
          }
        ]
        },
    },
    filters: {

      kayittipi: function (v) {

        var index = helpers.getBiletKayitTipi.filter(function (el) {
          return el.Kod == v
        });

        if (index.length >0) {
          return index[0].Aciklama
        } else {
          return null
        }


      },


      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },
    beforeMount: beforeMount,
    components: {
      yetkidialog,
      parainput,
      yuzdeinput,
      tarihcomp
    },
  }

  function Kaydet() {
    if (this.$refs.formgunluksatis.validate()) {


      var credentials = JSON.parse(window.localStorage.getItem('credentials'));


      this.VergiParametreYedek.SirketKodu = credentials.SirketKodu;

      var params = this.VergiParametreYedek;

      this.$http.post(auth.API_URL + 'api/TicketParametre/TempTaxParamSave', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {

        if (response.body.Status == true) {

          this.dialog = false;
          this.gecicivergibilgigetir();

        }


        this.text1 = response.body.ResponseMessage
        this.snackbar = true


      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true

        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true

        }
      })



    }

  }



  function ekle() {
    this.dialog = true
    this.KesenKisi.Kodu = null,
      this.KesenKisi.Adi = null,
      this.KesenKisi.Soyadi = null,
      this.dialog_baslik = 'Kesen Kişi Ekle'
    this.m = false
    this.k = true
    this.$validator.reset()
  }

  function beforeMount() {



  }

  function sil() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.KesenKisi.SirketKodu = credentials.SirketKodu

    var params = this.KesenKisi


    this.$http.post(auth.API_URL + 'api/TicketDefinitons/SalesmanDelete', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.text1 = response.body.ResponseMessage
      this.snackbar = true

      if (response.body.Status) {

        this.dialog = false
        var params = {
          SirketKodu: credentials.SirketKodu,
        }

        this.progress = true
        this.$http.post(auth.API_URL + 'api/TicketDefinitons/SalesmanList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.progress = false
          this.items = response.body
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.progress = false
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })

      } else {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true

      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })
  }


  function guncelle(value) {

    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.KesenKisi.SirketKodu = credentials.SirketKodu

        var params = this.KesenKisi

        this.$http.post(auth.API_URL + 'api/TicketDefinitons/SalesmanUpdate', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.text1 = response.body.ResponseMessage
          this.snackbar = true

          if (response.body.Status) {

            this.dialog = false
            var params = {
              SirketKodu: credentials.SirketKodu,
            }

            this.progress = true
            this.$http.post(auth.API_URL + 'api/TicketDefinitons/SalesmanList', params, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.progress = false
              this.items = response.body
            }, (response) => {
              if (response.status === 0) {
                this.progress = false
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.progress = false
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              }
            })

          } else {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true

          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>
</style>